import moment from 'moment'
import type React from 'react'
import styled from 'styled-components'

import Card from '@/components/Card'
import Tooltip from '@/components/IconGroup/TooltipIcon'
import type { SubjectBySearchResult } from '@/types/Subject'

import SubjectView from './SubjectView'

interface Props {
  onApplicantSelected: (subjectId: string) => void
  onApplicantAuxSelected: (subjectId: string) => void
  applicant?: SubjectBySearchResult
}

const AddressHeader = styled.h5`
  margin: 0;
  margin-bottom: 5px;
  font-weight: 500;
`

const AddressHeaderLine2 = styled.div`
  font-weight: 500;
  font-size: 15px;
`

const AssetHeader = styled.div`
  font-family: 'Montserrat', sans-serif;
  text-transform: capitalize;
`

const LastUpdated = styled.div`
  font-size: 11px;
`

const CardContainer = styled(Card)`
  &:hover {
    cursor: pointer;
    background: #f1f1f1;
  }
`

const CardHeader = styled.div`
  align-items: flex-start;
  margin-left: 15px;
  margin-right: 15px;
`

const ApplicantCard: React.FC<Props> = ({
  applicant,
  onApplicantSelected,
  onApplicantAuxSelected,
}) => {
  if (!applicant) {
    return <h1>Loading app...</h1>
  }

  return (
    <CardContainer
      onClick={() => onApplicantSelected(applicant.id)}
      onAuxClick={() => onApplicantAuxSelected(applicant.id)}
    >
      <CardHeader className="side-by-side-flex">
        <AssetHeader>
          {applicant.asset?.attributes?.address ? (
            <>
              <AddressHeader>
                {applicant?.asset?.attributes?.address.nameOrNumber?.toLowerCase()}{' '}
                {applicant?.asset?.attributes?.address.line1?.toLowerCase()}
              </AddressHeader>
              <AddressHeaderLine2>
                {applicant.asset.attributes?.address.city?.toLowerCase()}{' '}
                {applicant.asset.attributes?.address?.postcode}
              </AddressHeaderLine2>
            </>
          ) : (
            <span>No property provided</span>
          )}
        </AssetHeader>
        <Tooltip
          icon={
            <LastUpdated>
              Last updated {moment(applicant.updatedAt).fromNow()}
            </LastUpdated>
          }
          tooltipMessage={moment(applicant.updatedAt).format('LLLL')}
        />
      </CardHeader>
      <SubjectView applicant={applicant} />
    </CardContainer>
  )
}

export default ApplicantCard
